<script>
import cityMixin from "@/mixins/cityMixin";
import debounceMixin from "@/mixins/debounceMixin";
import { mapActions, mapState } from "vuex";

export default {
  mixins: [cityMixin, debounceMixin],

  data() {
    return {
      search: "",
      foundCities: []
    };
  },
  computed: {
    ...mapState("sendNotifications", ["cities"]),
    ...mapState("cities", ["text_search"])
  },
  methods: {
    ...mapActions("sendNotifications", ["setCities"]),
    ...mapActions("cities", ["searchByName"]),

    remove(item) {
      let cities = this.cities.filter(el => el != item.id);
      this.setCities(cities);
    },

    async debounceCallback(text) {
      try {
        let response = await this.searchByName(text);

        this.foundCities = response;

        this.$nextTick(() => {
          this.search = "";
        });
      } catch (e) {
        this.$toast.error(e);
      }
    }
  }
};
</script>

<template>
  <v-layout column>
    <span class="mb-3"
      >Caso deseje enviar para cidades específicas, selecione-as abaixo.</span
    >
    <v-autocomplete
      chips
      dense
      filled
      multiple
      clearable
      cache-items
      deletable-chips
      item-value="id"
      placeholder="Começe digitando o nome..."
      prepend-inner-icon="mdi-map-search-outline"
      :value="cities"
      :items="foundCities"
      :item-text="cityAndState"
      :close-on-content-click="false"
      @input="setCities"
      @update:search-input="debounce"
      :search-input.sync="search"
    ></v-autocomplete>
  </v-layout>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/Send/Steps/Cities.vue